import React, { createContext, useContext, useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebaseConfig"; // Adjust the path accordingly

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // To track if auth state is being checked

  useEffect(() => {
    const auth = getAuth();

    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Check if the user is an admin
        const userDocRef = doc(db, "users", user.uid);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists() && userDocSnap.data().admin) {
          setIsAdmin(true); // Set admin status to true
        } else {
          setIsAdmin(false); // User is not an admin
          localStorage.removeItem("isAdmin"); // Remove admin state from localStorage
        }
      } else {
        setIsAdmin(false); // No user is logged in
        localStorage.removeItem("isAdmin"); // Remove admin state from localStorage
      }
      setIsLoading(false); // Auth state check is complete
    });

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, []);

  return (
    <AdminContext.Provider value={{ isAdmin, setIsAdmin, isLoading }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
